import * as angular from "angular";

angular
  .module('app.translate', [
    'pascalprecht.translate',
    'LocalStorageModule'
  ]);
